import { Pages } from 'modules/navigation/domain/enums/pages';

/**
 * Страницы, которые открывает не человек, а машина: рендерер картинок медиа-менеджера
 * и OBS-источник трансляции. Аналитика и Session Replay там пишут мусор — каждую отрисовку
 * канвы, — поэтому инициализацию на них пропускаем.
 */
const HEADLESS_PREFIXES = [Pages.MEDIA_MANAGER.RENDER, Pages.MEDIA_MANAGER.RENDER_STANDINGS, Pages.MEDIA_MANAGER.STAT_RENDER];

/**
 * Оверлей трансляции — хвост пути, а не префикс: его роут объявлен шаблоном
 * `organizer/:organizerId/device/:deviceId/overlay` (`Pages.OVERLAY_V2.INDEX`),
 * начало у него динамическое, поэтому из `Pages` берётся только смысл, а не строка.
 * Панель управления (`/control-panel`) сюда не входит: ею пользуется живой оператор.
 */
const OVERLAY_SUFFIX = '/overlay';

export function isHeadlessRoute(pathname: string): boolean {
  const normalized = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;

  if (HEADLESS_PREFIXES.some((prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`))) {
    return true;
  }

  return normalized.endsWith(OVERLAY_SUFFIX);
}
